/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {generateLightningInvoice} from '../api'

export const useMutationGenerateLightningInvoice = createReactQueryMutationHook('generateLightningInvoice', generateLightningInvoice)
